@if (isInsideModal) {

  <aside [attr.aria-label]="'newsletter-modal'" class="c__newsletter" >

    @if (currentStep === 0) {
      <sd-html innerClass="c__message" [html]="getHTMLText(formSuccess ? data?.thanksSubtitle : data?.subtitle)" />
      <p class="c__mandatory-message is-caption c__a11y-legend brand--h5">
        {{ 'forms.mandatoryFields' | translate }}
      </p>
    } @else if (currentStep === 1) {
      <p class="c__message">
        <span class="brand--h5 d-block">{{'newsletter.offer.step2.subtitle1'|translate}}</span>
        {{'newsletter.offer.step2.subtitle2' | translate}}
      </p>
    }

    @if (data?.media) {
      <sd-banner [media]="data?.media" [hasAltText]="false" />
    }

    @let _formGroups = getFormGroups();
    @let _lastStep = _formGroups.length - 1;

    @if (!formSuccess && currentStep !== _lastStep) {
      <form [formGroup]="formNewsletter" [ngClass]="{'is-intrusive': isIntrusive, 'is-column': !isRow}">
        <!-- User Info Group -->
        <div class="c__main-info">
          @for (group of _formGroups; track trackGroupByName($index, group)) {
            <div class="c__newsletter-step {{currentStep === $index ? 'c__active-step':''}}">
              <div class="c__user-info" formGroupName="{{group}}">
                @for (control of getFormControls(group); track trackControlsByName($index, control)) {

                  @if (control.type === 'radio') {

                    <sd-form radio-group-inline
                      class="c__btn-group"
                      formControlName="{{control.name}}"
                      [nameField]="control.name"
                      [labelTitle]="control.label"
                      [items]="genderRadio"
                    >
                      <ng-container sd-message>
                        <sd-form-common-error [control]="formNewsletter.get(group).get(control.name)" />
                      </ng-container>
                    </sd-form>

                  } @else if (control.type === 'text') {

                    <sd-form-input
                      [id]="control.name"
                      formControlName="{{control.name}}"
                      type="text"
                      class="{{'c__newsletter-' + control.name}} {{control.inline ? ' c__inline-field' : ''}} "
                      [validStatus]="(control?.status !== 'VALID')"
                      [labelTitle]="control.label"
                      [placeholder]="control.placeholder"
                      [subLabelTitle]="control.subLabel"
                      [nameField]="control.name"
                      (blurEvent)="useDQEValidation && control.name === 'phone' ? validateInputOnBlur(formNewsletter.get(group).get('phone')) : null"
                    >
                      <ng-container sd-message>
                        @if (control.name === 'phone') {
                          <sd-form-error
                            errorKey="pattern"
                            [errorLabel]="(useDQEValidation ? 'forms.pickup.error.phone_' + formNewsletter.get(group).get('phone').errors?.idError :'forms.pickup.error.phone') | translate"
                            [control]="formNewsletter.get(group).get('phone')"
                          />
                        } @else if (control.name === 'phone') {
                          <sd-form-error
                            errorKey="required"
                            [errorLabel]="'forms.phone.required'| translate"
                            [control]="formNewsletter.get(group).get('phone')"
                          />
                        } @else if (control.name === 'firstName') {
                          <sd-form-common-error [control]="formNewsletter.get(group).get('firstName')" />
                        } @else if (control.name === 'lastName') {
                          <sd-form-common-error [control]="formNewsletter.get(group).get('lastName')" />
                        }
                      </ng-container>
                    </sd-form-input>

                  } @else if (control.type === 'number') {

                    <div class="c__house-hold-size-container">
                      <button sd-button
                        type="button"
                        icon="icon-minus"
                        [isSmall]="true"
                        [isIcon]="true"
                        class="is-theme-invert"
                        (click)="decreaseHouseHoldSize()"
                      ></button>
                      <sd-form-input
                        [id]="control.name"
                        formControlName="{{control.name}}"
                        type="number"
                        min="1"
                        max="99"
                        class="{{'c__newsletter-' + control.name}}"
                        [validStatus]="(control?.status !== 'VALID')"
                        [labelTitle]="control.label"
                        [placeholder]="control.placeholder"
                        [subLabelTitle]="control.subLabel"
                        [nameField]="control.name"
                      >
                        @if (formNewsletter.get(group).get('houseHoldSize').errors?.['min']) {
                          <sd-form-error
                            errorKey="pattern"
                            [errorLabel]="'newsletter.house.size.min'| translate"
                            [control]="formNewsletter.get(group).get('houseHoldSize')"
                          />
                        }
                        @if (formNewsletter.get(group).get('houseHoldSize').errors?.['max']) {
                          <sd-form-error
                            errorKey="pattern"
                            [errorLabel]="'newsletter.house.size.max'| translate"
                            [control]="formNewsletter.get(group).get('houseHoldSize')"
                          />
                        }
                      </sd-form-input>
                      <button sd-button
                        type="button"
                        icon="icon-plus"
                        [isSmall]="true"
                        [isIcon]="true"
                        class="is-theme-invert"
                        (click)="increaseHouseHoldSize()"
                      ></button>
                    </div>

                  } @else if (control.type === 'email') {

                    <sd-form-input
                      [id]="control.name"
                      formControlName="{{control.name}}"
                      type="email"
                      [validStatus]="(formNewsletter.get(group).get('email')?.status !== 'VALID')"
                      [nameField]="control.name"
                      [autocomplete]="useDQEValidation ? 'new-email' :'on'"
                      [suggestions]="suggestions"
                      [labelTitle]="control.label"
                      [placeholder]="control.placeholder"
                      (inputChanged)="onInputChanged()"
                      (blurEvent)="useDQEValidation ? validateInputOnBlur(formNewsletter.get(group).get('email')) : null"
                      >
                      <ng-container sd-message>
                        <sd-form-error
                          errorKey="pattern"
                          [errorLabel]="(useDQEValidation ? 'newsletter.emailPatternError_' + formNewsletter.get(group).get('email')?.errors?.idError: 'newsletter.emailPatternError') | translate:{eMail:formNewsletter.get(group).get('email').errors?.suggestedEmail}"
                          [control]="formNewsletter.get(group).get(control.name)"
                        />
                        <sd-form-error
                          errorKey="required"
                          [errorLabel]="'forms.email.required' | translate"
                          [control]="formNewsletter.get(group).get(control.name)"
                        />
                      </ng-container>
                    </sd-form-input>

                  } @else if (control.type === 'date') {

                    <sd-form-input
                      [id]="control.name"
                      class="{{'c__newsletter-' + control.name}}"
                      formControlName="{{control.name}}"
                      [validStatus]="(formNewsletter.get(group).get(control.name)?.status !== 'VALID')"
                      [labelTitle]="control.label"
                      [placeholder]="control.placeholder"
                      [subLabelTitle]="control.subLabel"
                      type="date"
                    >
                      <ng-container sd-message>
                        <sd-form-common-error [control]="formNewsletter.get(group).get(control.name)" />
                      </ng-container>
                    </sd-form-input>

                  }
                }
              </div>
            </div>
          }
        </div>
      </form>
    }

    @if (currentStep === _lastStep) {
      <sd-html
        innerClass="c__newsletter-last-step is-text-left"
        [html]="getHTMLText('newsletter.offer.step3.paragraph' | translate)"
        tab="div"
      />
    }

  </aside>

} @else {

  <aside [attr.aria-label]="'newsletter'" class="c__newsletter">
    @if (data?.title || data?.thanksTitle) {
      <sd-html
        innerClass="c__title brand--h3"
        [html]="formSuccess ? getHTMLText(data?.thanksTitle) : getHTMLText(data?.title)"
        tag="div"
      />
    }

    @if (data?.subtitle || data?.thanksSubtitle) {
      <sd-html
        innerClass="c__message brand--h5"
        [html]="formSuccess ? getHTMLText(data?.thanksSubtitle) : getHTMLText(data?.subtitle)"
        tag="div"
      />
    }

    @if (data?.media) {
      <sd-banner [media]="data?.media" [hasAltText]="false" />
    }

    @if (!formSuccess) {
      <form [formGroup]="formNewsletter" [ngClass]="{'is-intrusive': isIntrusive, 'is-column': !isRow}">
        @if (formNewsletter) {
          <div class="c__main-info">
            <sd-form-input
              formControlName="formInput"
              #inputNewsletter
              [autocomplete]="useDQEValidation ? 'new-email' :'on'"
              [validStatus]="(formNewsletter.controls.formInput.status !== 'VALID')"
              [labelTitle]="'newsletter.emailInputLabel' | translate"
              [placeholder]="'newsletter.placeholder' | translate"
              nameField="Newsletter Input"
              type="email"
              [required]="true"
              [suggestions]="suggestions"
              (inputChanged)="onInputChanged()"
              (blurEvent)="useDQEValidation ? validateInputOnBlur(formNewsletter.get('formInput')) : null"
            >
              <ng-container sd-message>
                <sd-form-error errorKey="pattern"
                  [errorLabel]="(useDQEValidation ? 'newsletter.emailPatternError_'+formNewsletter.get('formInput').errors?.idError: 'newsletter.emailPatternError') | translate:{eMail:formNewsletter.get('formInput').errors?.suggestedEmail}"
                  [control]="formNewsletter.get('formInput')"
                />
                <sd-form-error
                  errorKey="required"
                  [errorLabel]="'forms.email.required' | translate"
                  [control]="formNewsletter.get('formInput')"
                />
              </ng-container>
            </sd-form-input>

            @if (!isIntrusive) {
              <button sd-button
                type="submit"
                [attr.title]="data?.newsletterSubscribe"
                (click)="onSubmit()"
              >
                {{ data?.newsletterSubscribe }}
              </button>
            }
          </div>

          @if (isIntrusive) {
            <div class="c__personnal-info">
              <sd-form-input
                formControlName="formLastName"
                #inputLastNameNewsletter
                autocomplete="on"
                [validStatus]="(formNewsletter.controls.formLastName.status !== 'VALID')"
                [labelTitle]="'newsletter.lastName.label' | translate"
                [placeholder]="'newsletter.lastName.placeholder' | translate"
                nameField="Newsletter Input"
              >
                <ng-container sd-message>
                  <sd-form-common-error [control]="formNewsletter.get('formLastName')" />
                </ng-container>
              </sd-form-input>

              <sd-form-input
                formControlName="formFirstName"
                #inputFirstNameNewsletter
                autocomplete="on"
                [validStatus]="(formNewsletter.controls.formFirstName.status !== 'VALID')"
                [labelTitle]="'newsletter.firstName.label' | translate"
                [placeholder]="'newsletter.firstName.placeholder' | translate"
                nameField="Newsletter Input"
              >
                <ng-container sd-message>
                  <sd-form-common-error [control]="formNewsletter.get('formFirstName')" />
                </ng-container>
              </sd-form-input>

              @if (isRow) {
                <div class="c__action">
                  <button sd-button
                    type="submit"
                    [attr.title]="data?.newsletterSubscribe"
                    (click)="onSubmit()"
                  >
                    {{ data?.newsletterSubscribe }}
                  </button>
                </div>
              }
            </div>
          }

          <sd-form checkbox
            formControlName="formCheckbox"
            #newsletterCheckbox
            class="is-aligned-top"
            customClass="is-caption"
            [labelTitle]="data?.checkboxLabel"
            nameField="agree-newsletter"
            [required]="true"
          >
            <ng-container sd-message>
              <sd-form-error
                errorKey="required"
                [errorLabel]="'newsletter.termsRequired' | translate"
                [control]="formNewsletter.get('formCheckbox')"
              />
            </ng-container>
          </sd-form>
        }
      </form>
    }
  </aside>
}
